import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ServiceLayer from "../components/ServiceLayer";

const ServicePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Service' />

        {/* GalleryLayer */}
        <ServiceLayer />
      </MasterLayout>
    </>
  );
};

export default ServicePage;
